const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCss3Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#264de4",
    d: "M 46.5,-0.5 C 281.833,-0.5 517.167,-0.5 752.5,-0.5C 731.222,239.838 709.888,480.172 688.5,720.5C 593.187,746.076 498.187,772.409 403.5,799.5C 400.833,799.5 398.167,799.5 395.5,799.5C 300.761,772.592 205.761,746.259 110.5,720.5C 89.0465,480.178 67.7132,239.845 46.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2965f1",
    d: "M 398.5,646.5 C 398.833,646.5 399.167,646.5 399.5,646.5C 459.659,629.752 519.826,613.086 580,596.5C 593.424,448.851 606.591,301.184 619.5,153.5C 620.468,151.393 620.802,149.059 620.5,146.5C 546.833,146.5 473.167,146.5 399.5,146.5C 399.5,117.167 399.5,87.8333 399.5,58.5C 495.5,58.5 591.5,58.5 687.5,58.5C 669.116,263.436 651.116,468.436 633.5,673.5C 555.663,695.418 477.663,716.751 399.5,737.5C 399.825,707.093 399.492,676.76 398.5,646.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cdd8f5",
    d: "M 178.5,147.5 C 251.998,146.501 325.665,146.167 399.5,146.5C 473.167,146.5 546.833,146.5 620.5,146.5C 620.802,149.059 620.468,151.393 619.5,153.5C 619.5,151.5 619.5,149.5 619.5,147.5C 546.167,147.5 472.833,147.5 399.5,147.5C 325.833,147.5 252.167,147.5 178.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eaeaeb",
    d: "M 178.5,147.5 C 252.167,147.5 325.833,147.5 399.5,147.5C 399.5,176.5 399.5,205.5 399.5,234.5C 328.5,234.5 257.5,234.5 186.5,234.5C 183.365,205.689 180.699,176.689 178.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 399.5,147.5 C 472.833,147.5 546.167,147.5 619.5,147.5C 619.5,149.5 619.5,151.5 619.5,153.5C 606.591,301.184 593.424,448.851 580,596.5C 519.826,613.086 459.659,629.752 399.5,646.5C 399.175,615.76 399.508,585.093 400.5,554.5C 432.716,545.569 465.049,536.902 497.5,528.5C 501.194,490.202 504.527,451.869 507.5,413.5C 471.5,413.5 435.5,413.5 399.5,413.5C 399.5,384.167 399.5,354.833 399.5,325.5C 438.167,325.5 476.833,325.5 515.5,325.5C 518.078,295.159 520.745,264.825 523.5,234.5C 482.167,234.5 440.833,234.5 399.5,234.5C 399.5,205.5 399.5,176.5 399.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e66f0",
    d: "M 186.5,234.5 C 257.5,234.5 328.5,234.5 399.5,234.5C 440.833,234.5 482.167,234.5 523.5,234.5C 520.745,264.825 518.078,295.159 515.5,325.5C 476.833,325.5 438.167,325.5 399.5,325.5C 331.167,325.5 262.833,325.5 194.5,325.5C 262.665,324.501 330.998,324.167 399.5,324.5C 399.5,294.833 399.5,265.167 399.5,235.5C 328.331,235.833 257.331,235.499 186.5,234.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eaeaeb",
    d: "M 194.5,325.5 C 262.833,325.5 331.167,325.5 399.5,325.5C 399.5,354.833 399.5,384.167 399.5,413.5C 333.5,413.5 267.5,413.5 201.5,413.5C 199.407,384.146 197.074,354.812 194.5,325.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2a65f0",
    d: "M 201.5,413.5 C 267.5,413.5 333.5,413.5 399.5,413.5C 435.5,413.5 471.5,413.5 507.5,413.5C 504.527,451.869 501.194,490.202 497.5,528.5C 465.049,536.902 432.716,545.569 400.5,554.5C 400.167,554.5 399.833,554.5 399.5,554.5C 399.5,507.833 399.5,461.167 399.5,414.5C 333.331,414.832 267.331,414.499 201.5,413.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9babe7",
    d: "M 294.5,458.5 C 264.814,457.841 235.481,458.508 206.5,460.5C 205.596,459.791 205.263,458.791 205.5,457.5C 235.338,457.169 265.005,457.502 294.5,458.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eaeaeb",
    d: "M 294.5,458.5 C 296.469,481.816 298.802,505.15 301.5,528.5C 334.162,537.297 366.829,545.964 399.5,554.5C 399.833,554.5 400.167,554.5 400.5,554.5C 399.508,585.093 399.175,615.76 399.5,646.5C 399.167,646.5 398.833,646.5 398.5,646.5C 338.127,629.99 277.794,613.323 217.5,596.5C 214.127,551.144 210.461,505.811 206.5,460.5C 235.481,458.508 264.814,457.841 294.5,458.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3Svg);
export default __webpack_public_path__ + "static/media/CSS3.svg.3b577af4d361cb74901bbc1b94fa7726.svg";
export { ForwardRef as ReactComponent };